import React from 'react';

const InvestBenefits = ({ investment_benefits }) => {
  return (
    <div>
      <div className="wg-property single-property-nearby">
        <div className="wg-title text-11 fw-6 text-color-heading">Investment Benefits</div>
        <div className="row box-nearby gap-2">
            <div  className="col-md-12 ">
              <ul className="box-benefits flex-column gap-4">
              {Object.entries(investment_benefits).map(([title, value], index) => (
                <li key={index} className="item-benefit d-flex flex-column flex-md-row gap-2">
                  <p className="fw-7 label text-4 whitespace-nowrap">{title}:</p>
                  <p>{value}</p>
                </li>
                 ))}
              </ul>
            </div>
         
        </div>
      </div>
    </div>
  );
};

export default InvestBenefits;
